import { styled } from 'styled-components'
import type { UseDraggableArguments } from '@dnd-kit/core'

export const DragWrapper = styled.span<Omit<UseDraggableArguments, 'id'>>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'grab')};
`
